<template>
	<div id="app">
		<Form
			:campaignId="campaignId"
			:testMode="testMode"
			:loadParamsFn="loadParamsFn"
			:completedFn="completedFn"
		/>
	</div>
</template>

<script>
import Form from "./views/Form.vue";

export default {
	name: "App",
	data() {
		return {};
	},
	components: {
		Form,
	},
	props: {
		campaignId: {
			type: String,
			default: "",
		},
		testMode: {
			type: Boolean,
		},
		loadParamsFn: {
			type: undefined,
		},
		completedFn: {
			type: undefined,
		},
	},
};
</script>

<style lang="scss">
@font-face {
	font-family: "Cabin";
	src: local("Cabin"), url("../public/fonts/Cabin-VariableFont_wdth,wght.ttf");
}


#app {
	font-family: Cabin, Arial, Helvetica, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
}
</style>
